export function snapTo (num, interval) {
  return Math.round(num / interval) * interval;
}

export function clamp (min, value, max) {
  return Math.min(max, Math.max(min, value));
}

// Adapted from https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url
export function getYoutubeCode (url) {
  if (/^[a-z0-9_\-]*:\/\/([a-z0-9_\-\.]*\.)?(youtube\.com|youtu\.be)($|\/|\?)/i.test(url)) {
    let match = url.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/i);
    return (match && match[7].length === 11) ? match[7] : null;
  }

  return false;
}

export function getVimeoCode (url) {
  if (/^[a-z0-9_\-]*:\/\/([a-z0-9_\-\.]*\.)?vimeo.com($|\/|\?)/i.test(url)) {
    let parts = url.match(/^[a-z0-9_\-]*:\/\/([a-z0-9_\-\.]*\.)?vimeo.com\/([^?#]+)/i)[2].split('/');

    while (true) {
      if (parts[0] === 'album' || parts[0] === 'channels' || parts[0] === 'groups' || parts[0] === 'ondemand') {
        parts.splice(0, 2);
        continue;
      }

      if (parts[0] === 'video' || parts[0] === 'videos') {
        parts.splice(0, 1);
        continue;
      }

      break;
    }

    if (parts.length === 1 && isFinite(parts[0])) {
      return parts[0];
    }

    return null;
  }

  return false;
}

export function getElementColor (element, colors, hover) {
  let color = hover ? (element.hovercolor || element.color) : element.color;
  return element && color && colors[color] && colors && colors[color].value || '#FFFFFF';
}

export function getElementAltColor (element, colors, hover) {
  let color = hover ? (element.hovercolor || element.color) : element.color;
  return element && color && colors[color] && colors && colors[color].other || '#000000';
}

export function getPrimaryColor (s) {
  return (s.colors[s.primaryColor || '0-0-normal'] || s.colors['0-0-normal']).value;
}

export function getPrimaryAltColor (s) {
  return (s.colors[s.primaryColor || '0-0-normal'] || s.colors['0-0-normal']).other;
}

export function getPrimaryContrastColor (s) {
  return (s.colors[s.primaryColor || '0-0-normal'] || s.colors['0-0-normal']).contrast;
}

export function getSecondaryColor (s) {
  return (s.colors[s.secondaryColor || '0-0-normal'] || s.colors['0-0-normal']).value;
}

export function getSecondaryAltColor (s) {
  return (s.colors[s.secondaryColor || '0-0-normal'] || s.colors['0-0-normal']).other;
}

export function getSecondaryContrastColor (s) {
  return (s.colors[s.secondaryColor || '0-0-normal'] || s.colors['0-0-normal']).contrast;
}

export function prepareData (s) {
  if (!s.elements) {
    s.elements = [];
  }

  if (!s.nextId) {
    s.nextId = 1;
  }

  s.globalSettings = s.globalSettings || {};
  s.globalSettings.assetVolume = s.globalSettings.assetVolume || {};

  if (!s.layerSettings) {
    s.layerSettings = {};
  }

  if (s.layerSettings) {
    for (let index in s.layerSettings) {
      if (s.layerSettings[index]) {
        if (s.layerSettings[index].states) {
          s.layerSettings[index].states = {};
          s.layerSettings[index].autoplayAudio = s.layerSettings[index].autoplayAudio || '';
        }

        delete s.layerSettings[index].splashFontFamily;
      }
    }
  }

  for (let index in s.elements) {
    if (s.elements[index]) {
      if (s.elements[index]['stateInvert'] !== undefined) {
        if (!s.elements[index]['stateHandling']) {
          s.elements[index]['stateHandling'] = s.elements[index]['stateInvert'] ? 'hide for any' : 'show for any';
        }

        delete s.elements[index]['stateInvert'];
      }

      if (s.elements[index].type === 'text') {
        s.elements[index].lineHeight = s.elements[index].lineHeight || 1.15;
        s.elements[index].fontFamily = s.elements[index].fontFamily || '';
        s.elements[index].fontSize = s.elements[index].fontSize || 'default';
        s.elements[index].fontWeight = s.elements[index].fontWeight || 'default';
        s.elements[index].textAlign = s.elements[index].textAlign || 'default';
      }

      if (s.elements[index].type === 'button') {
        s.elements[index].fontFamily = s.elements[index].fontFamily || '';
        s.elements[index].fontSize = s.elements[index].fontSize || 'default';
        s.elements[index].fontWeight = s.elements[index].fontWeight || 'default';
      }

      if (!s.elements[index].action) {
        s.elements[index].action = [];
      }

      if (typeof s.elements[index].action === 'string') {
        s.elements[index].action = [s.elements[index].action];
      }

      if (typeof s.elements[index].hovercolor !== 'string') {
        s.elements[index].hovercolor = '';
      }

      if (typeof s.elements[index].nonhover !== 'string') {
        s.elements[index].nonhover = '';
      }

      if (typeof s.elements[index].hover !== 'string') {
        s.elements[index].hover = '';
      }

      if (typeof s.elements[index].url !== 'string') {
        s.elements[index].url = '';
      }

      if (typeof s.elements[index].transform !== 'string') {
        s.elements[index].transform = '';
      }

      s.elements[index].action = s.elements[index].action.filter(Boolean);
    }
  }

  for (let index in s.assets) {
    if (s.assets[index].type === 'remote_video' && s.assets[index].url) {
      let code;

      if (code = getYoutubeCode(s.assets[index].url)) {
        s.assets[index].provider = 'youtube';
        s.assets[index].code = code;
      } else if (code = getVimeoCode(s.assets[index].url)) {
        s.assets[index].provider = 'vimeo';
        s.assets[index].code = code;
      }
    }

    if (s.assets[index].type === 'audio') {
      if (s.globalSettings.assetVolume[index] === undefined) {
        s.globalSettings.assetVolume[index] = 1;
      }
    }
    else {
      delete s.globalSettings.assetVolume[index];
    }
  }
}

export const stateChecks = {
  'show for any': (needed, provided) => {
    for (let key in needed) {
      if (needed[key] && provided[key]) {
        return true;
      }
    }

    return false;
  },
  'show for all': (needed, provided) => {
    for (let key in needed) {
      if (needed[key] && !provided[key]) {
        return false;
      }
    }

    return true;
  },
  'hide for any': (needed, provided) => {
    for (let key in needed) {
      if (needed[key] && provided[key]) {
        return false;
      }
    }

    return true;
  },
  'hide for all': (needed, provided) => {
    for (let key in needed) {
      if (needed[key] && !provided[key]) {
        return true;
      }
    }

    return false;
  },
};

// Not safe against circular dependencies.
export function duplicate(any) {
  if (typeof any !== 'object') {
    return any;
  }

  let ret = new any.constructor();

  for (let key in any) {
    ret[key] = duplicate(any[key]);
  }

  return ret;
}

export function debounce(func, ms) {
  let timeout = null;

  return function (...args) {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }

    timeout = setTimeout(() => {
      func.apply(this, args);
    }, ms);
  }
}

export default {
  snapTo,
  clamp,
  getYoutubeCode,
  getVimeoCode,
  prepareData,
  stateChecks,
  getElementColor,
  getElementAltColor,
  getPrimaryColor,
  getPrimaryAltColor,
  getSecondaryColor,
  getSecondaryAltColor,
  duplicate,
  debounce,
};
